import { StyleSheet } from 'aphrodite'

import main from './main'
import table from './table'
import headers from './headers'
import tableRow from './tableRow'
import editable from './editable'

export default {
  main: StyleSheet.create(main),
  table: StyleSheet.create(table),
  headers: StyleSheet.create(headers),
  tableRow: StyleSheet.create(tableRow),
  editable: StyleSheet.create(editable)
}



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/style/ColorBlind/index.js